/*******************************************************************************
 * measureStringDifference
 * This is a simple implementation of the Levenshtein distance algorithm. It
 * measures the difference between two strings by counting the number of edits
 * required to transform one string into the other a character at a time. The
 * larger the number, the more different the strings are.
 */

export function measureStringDifference(a: string, b: string): number {
	// Columns for a, rows for b
	const matrix = [];

	// Increment along the first column of each row
	for (let i = 0; i <= b.length; i++) {
		matrix[i] = [i];
	}

	// Increment each column in the first row
	for (let j = 0; j <= a.length; j++) {
		matrix[0][j] = j;
	}

	// Fill in the rest of the matrix
	for (let i = 1; i <= b.length; i++) {
		// rows
		for (let j = 1; j <= a.length; j++) {
			// columns
			// cells at row i and column j
			if (b.charAt(i - 1) === a.charAt(j - 1)) {
				// i = 0, j = 0, the empty strings will match, will set the value to 0
				matrix[i][j] = matrix[i - 1][j - 1];
			} else {
				matrix[i][j] = Math.min(
					matrix[i - 1][j - 1] + 1, // substitution
					matrix[i][j - 1] + 1, // insertion
					matrix[i - 1][j] + 1,
				);
			}
		}
	}
	return matrix[b.length][a.length];
}
